/*!
 * Copyright © 2019-2020. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

import { EDriverWorkingState } from 'tacho';

import { IDriverStatus, EDriverStatusSortType, MarkerInfo, IZoomToMarkerParams, IMapContextMenuData } from '../../../core/models';
import { ButtonToggleComponent } from '../../../core/components';

@Component({
  selector: 'fm-driver-status-panel',
  templateUrl: './driver-status-panel.component.html',
  styleUrls: ['./driver-status-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DriverStatusPanelComponent {
  @Input()
  public driverStatusData: IDriverStatus[];
  @Input()
  public driverStatusFilter: EDriverWorkingState;
  @Input()
  public isDriverBreakDueFilterSelected: boolean;
  @Input()
  public driverStatusSortType: EDriverStatusSortType;
  @Input()
  public isDriverPlannerPageAllowed: boolean;

  @Output()
  public filterChange: EventEmitter<EDriverWorkingState> = new EventEmitter();
  @Output()
  public driverBreakDueFilterChanged: EventEmitter<boolean> = new EventEmitter();
  @Output()
  public driverStatusSortTypeChanged: EventEmitter<EDriverStatusSortType> = new EventEmitter();
  @Output()
  public highlightMarker = new EventEmitter<number>();
  @Output()
  public removeMarkerHighlight = new EventEmitter<void>();
  @Output()
  public selectVehiclesClicked = new EventEmitter<void>();
  @Output()
  public openDriverStatusContextMenu = new EventEmitter<IMapContextMenuData<MarkerInfo>>();
  @Output()
  public triggerZoomTo = new EventEmitter<IZoomToMarkerParams>();
  @Output()
  public openDriverPlanner = new EventEmitter<void>();

  public EDriverWorkingState = EDriverWorkingState;
  public EDriverStatusSortType = EDriverStatusSortType;

  public onFilterChange(driverState: EDriverWorkingState): void {
    this.filterChange.emit(driverState);
  }

  public onIsDriverBreakDueFilterSelectedChange(selectedButton: ButtonToggleComponent): void {
    this.driverBreakDueFilterChanged.emit(selectedButton.isSelected);
  }

  public onStatusSortTypeChange(statusSortType: EDriverStatusSortType): void {
    this.driverStatusSortTypeChanged.emit(statusSortType);
  }

  public onOpenDriverStatusContextMenu(menuData: IMapContextMenuData<MarkerInfo>): void {
    this.openDriverStatusContextMenu.emit(menuData);
  }

  public onSelectVehiclesClicked(): void {
    this.selectVehiclesClicked.emit();
  }

  public onHighlightMarker(vehicleId: number): void {
    this.highlightMarker.emit(vehicleId);
  }

  public onRemoveMarkerHighlight(): void {
    this.removeMarkerHighlight.emit();
  }

  public onDriverPlannerButtonClick(): void {
    this.openDriverPlanner.emit();
  }

  public selectionCleared(): void {
    this.filterChange.emit(null);
  }

  public zoomToPosition(params: IZoomToMarkerParams): void {
    this.triggerZoomTo.emit(params);
  }
}
